<template>
  <div id="app">
    <clublink-header />
    <router-view/>
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <a href="https://gitlab.com/clublink-manager/client">GitLab</a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import ClublinkHeader from '@/components/ClublinkHeader.vue'

export default {
  name: 'App',
  components: {
    ClublinkHeader
  }
}
</script>
